export default __webpack_public_path__ + "static/media/cz_dark.79bf156d.png";